import { render, staticRenderFns } from "./TestRecord.vue?vue&type=template&id=1c2c3532&scoped=true&"
import script from "./TestRecord.vue?vue&type=script&lang=js&"
export * from "./TestRecord.vue?vue&type=script&lang=js&"
import style0 from "./TestRecord.vue?vue&type=style&index=0&id=1c2c3532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2c3532",
  null
  
)

export default component.exports